<template>
  <div class="button-container">
    <transition name="fade">
      <div class="modal" v-show="show">
        <div class="modal-layout" @click="toggleShow"></div>
        <div :class="'modal-content ' + modalContentClass">
          <div class="modal-close" @click="toggleShow">X</div>
          <slot></slot>
        </div>
      </div>
    </transition>
    <button :class="buttonClass" @click="toggleShow">
      {{ buttonText }}
    </button>
  </div>
</template>


<script>
export default {
  name: "popup-button",
  props: {
    trigger: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: "Button"
    },
    buttonClass: {
      type: String,
      default: ""
    },
    modalContentClass: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      show: false
    };
  },
  watch: {
    trigger: function(trigger) {
      this.show = trigger;
    },
    show: function(show) {
      this.$emit("toggle-show", show);
    }
  },
  methods: {
    toggleShow: function() {
      return (this.show = !this.show);
    }
  }
};
</script>
